import Vue from 'vue'
import Router from 'vue-router'
import bp from '@/views/bimplus/index'
import cloud from '@/views/cloudStructure/index'

import privacy from '@/views/privacy/privacy'
import service from '@/views/privacy/service'
import privacyCloud from '@/views/privacyCloud/privacy'
import serviceCloud from '@/views/privacyCloud/service'
// TODO: change 'privacy/' to 'legal/'

import playground from '@/views/index/index'
import userInfo from '@/views/userInfo'

import { getCookie, getUri } from '@/uitls/index'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '用户中心 | 登录'
      },
      component: playground
    },
    {
      path: '/signup',
      name: 'signup',
      meta: {
        title: '用户中心 | 注册'
      },
      component: playground
    },
    {
      path: '/recovery',
      name: 'recovery',
      meta: {
        title: '用户中心 | 找回'
      },
      component: playground
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        title: '隐私政策'
      },
      component: privacy
    },
    {
      path: '/service',
      name: 'service',
      meta: {
        title: '服务协议'
      },
      component: service
    },
    {
      path: '/privacyCloud',
      name: 'privacyCloud',
      meta: {
        title: '隐私政策'
      },
      component: privacyCloud
    },
    {
      path: '/serviceCloud',
      name: 'serviceCloud',
      meta: {
        title: '服务协议'
      },
      component: serviceCloud
    },
    {
      path: '/bp',
      name: 'bp',
      meta: {
        title: '共享中心'
      },
      component: bp
    },
    {
      path: '/cloud',
      name: 'cloud',
      component: cloud
    },
    {
      path: '/detail',
      name: 'detail',
      alias: ['/user'],
      meta: {
        title: '用户中心 | 详情',
        authorize: true,
        clean: true
      },
      component: userInfo
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

router.afterEach((to, from) => {
  let title = to.meta.title
  window.document.title = title ? title : ''
})

router.beforeEach((to, from, next) => {
  // intercept redirect
  let redirect = to.query.redirect_url
  // console.log(redirect)
  if (redirect) {
    let uri = getUri(redirect)
    // TODO: check uri hostname
    // if (uri.hostname.indexOf("vanke.com") < 0) {
    //   next({
    //     name: to.name
    //   })
    //   return
    // }
    if (process.env.REDIRECT_BP == uri.hostname) {
      next({
        name: 'bp'
      })
      return
    }
    if (to.meta.clean) {
      next({
        name: to.name
      })
      return
    }
  }
  // check TOKEN (not verify)
  if (to.meta.authorize) {
    let token = getCookie('accesstoken')
    if (!token) {
      next({
        name: 'login'
      })
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js